import { render, staticRenderFns } from "./fdInventory48.vue?vue&type=template&id=37ae3bc8"
import script from "./fdInventory48.vue?vue&type=script&lang=js"
export * from "./fdInventory48.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports